/**
 * @generated SignedSource<<8771c8a8c128dc4b6e78a1295f89cc9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type heroThreeArticlesQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  };
  readonly " $fragmentType": "heroThreeArticlesQueueItemsEdge";
}>;
export type heroThreeArticlesQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: heroThreeArticlesQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroThreeArticlesQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "heroThreeArticlesQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "contentItemRenderContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "1fd9e5be93b4c111d476d3bbcb3913d4";

export default node;
